/**
 * In-memory cache for GET /GetServerMonitoringFlags responses.
 * Global flags list (not scoped by branch).
 */

const CACHE_KEY = 'server-monitoring-flags';
const cache = new Map();

/**
 * @returns {{ flags: object[], refreshedAt: number } | null}
 */
export function getServerMonitoringFlagsCache() {
  return cache.get(CACHE_KEY) ?? null;
}

export function setServerMonitoringFlagsCache(entry) {
  if (!entry?.flags || !Array.isArray(entry.flags)) return;
  cache.set(CACHE_KEY, {
    flags: entry.flags,
    refreshedAt: entry.refreshedAt ?? Date.now(),
  });
}

export function invalidateServerMonitoringFlagsCache() {
  cache.delete(CACHE_KEY);
}
